import * as React from 'react'
import UIMessages from 'src/utils/ui-messages'
import FindIcon from '../../icons/ui/Find'

interface IServicesSearchProps {
  orgId: string
  type: string
  onInputChange: (orgId: string, query: string, type: string) => void
}

const ServicesSearch = (props: IServicesSearchProps) => {
  const [searchValue, setSearchValue] = React.useState('')
  const handleInputChange = (e: any) => {
    const { onInputChange, orgId, type } = props
    const regex = /[\\\/\$\|\&\%\#\.\?]/g
    const searchString = e.target.value.replaceAll(regex, '')
    setSearchValue(searchString)
    if (orgId) {
      onInputChange(orgId, searchString, type)
    }
  }

  return (
    <div className='flex items-center mr3'>
      <input
        className='w3-input mr1'
        type='text'
        value={searchValue}
        onChange={handleInputChange}
        placeholder={UIMessages.common.search}
      />
      <FindIcon className='svg-stroke-grey3' />
    </div>
  )
}

export default ServicesSearch



// WEBPACK FOOTER //
// ./src/components/services/list/ServicesSearch.tsx